module.exports = __webpack_public_path__ + "static/media/author3.30bf80c8.jpg";